import axios, { AxiosRequestConfig } from "axios";

export const globalAxiosInstance = axios.create();

const parseToken = (cookieName: string) => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(cookieName))
    ?.split("=")[1];
};

const requestInterceptorTokenAppender = async (req: AxiosRequestConfig) => {
  const token = parseToken("token");
  if (req.headers) {
    req.headers.authorization = `Bearer ${token}`;
  }
  return req;
};

globalAxiosInstance.interceptors.request.use(requestInterceptorTokenAppender);
